module.exports = __webpack_public_path__ + "static/img/police.5dff8cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/police.png
// module id = g0FG
// module chunks = 1